// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: Arial, sans-serif;
}

.App {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #0e1c31;
    color: #fff;
}

.chat-container {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.message {
    max-width: 70%;
    margin-bottom: 15px;
    padding: 10px 15px;
    border-radius: 20px;
    animation: fadeIn 0.5s ease-out;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.user {
    align-self: flex-end;
    background-color: #4a90e2;
    color: white;
    border-bottom-right-radius: 0;
}

.bot {
    align-self: flex-start;
    background-color: #2c3e50;
    color: #ecf0f1;
    border-bottom-left-radius: 0;
}

form {
    display: flex;
    padding: 20px;
    background-color: #1a2a43;
}

input {
    flex-grow: 1;
    padding: 10px;
    border: none;
    border-radius: 25px;
    background-color: #2c3e50;
    color: #ecf0f1;
    font-size: 16px;
}

input::placeholder {
    color: #95a5a6;
}

button {
    margin-left: 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 25px;
    background-color: #4a90e2;
    color: white;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

button:hover {
    background-color: #3a7bd5;
}

.typing-indicator {
    display: flex;
    justify-content: center;
}

.typing-indicator span {
    height: 10px;
    width: 10px;
    background-color: #3498db;
    border-radius: 50%;
    display: inline-block;
    margin: 0 3px;
    animation: bounce 1.3s linear infinite;
}

.typing-indicator span:nth-child(2) {
    animation-delay: -1.1s;
}

.typing-indicator span:nth-child(3) {
    animation-delay: -0.9s;
}

@keyframes bounce {
    0%,
    60%,
    100% {
        transform: translateY(0);
    }
    30% {
        transform: translateY(-10px);
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;IAEI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;;;QAGI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":["body,\nhtml {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    font-family: Arial, sans-serif;\n}\n\n.App {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    background-color: #0e1c31;\n    color: #fff;\n}\n\n.chat-container {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.message {\n    max-width: 70%;\n    margin-bottom: 15px;\n    padding: 10px 15px;\n    border-radius: 20px;\n    animation: fadeIn 0.5s ease-out;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.user {\n    align-self: flex-end;\n    background-color: #4a90e2;\n    color: white;\n    border-bottom-right-radius: 0;\n}\n\n.bot {\n    align-self: flex-start;\n    background-color: #2c3e50;\n    color: #ecf0f1;\n    border-bottom-left-radius: 0;\n}\n\nform {\n    display: flex;\n    padding: 20px;\n    background-color: #1a2a43;\n}\n\ninput {\n    flex-grow: 1;\n    padding: 10px;\n    border: none;\n    border-radius: 25px;\n    background-color: #2c3e50;\n    color: #ecf0f1;\n    font-size: 16px;\n}\n\ninput::placeholder {\n    color: #95a5a6;\n}\n\nbutton {\n    margin-left: 10px;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 25px;\n    background-color: #4a90e2;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\nbutton:hover {\n    background-color: #3a7bd5;\n}\n\n.typing-indicator {\n    display: flex;\n    justify-content: center;\n}\n\n.typing-indicator span {\n    height: 10px;\n    width: 10px;\n    background-color: #3498db;\n    border-radius: 50%;\n    display: inline-block;\n    margin: 0 3px;\n    animation: bounce 1.3s linear infinite;\n}\n\n.typing-indicator span:nth-child(2) {\n    animation-delay: -1.1s;\n}\n\n.typing-indicator span:nth-child(3) {\n    animation-delay: -0.9s;\n}\n\n@keyframes bounce {\n    0%,\n    60%,\n    100% {\n        transform: translateY(0);\n    }\n    30% {\n        transform: translateY(-10px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
